export enum AppUrls {
  ROOT = '/',
  Login = 'login',
  Startup = 'startup',
  Settings = 'settings',
  Home = 'home',
  TransportDetails = 'transport-details',
  TransportPlan = 'transport-plan',
  HomeDeliveryDetails = 'home-delivery-details'
}
